//public variables and secret keys
import moment from "moment-timezone";
let documentTitle = "Attorney Application";
let API_BASE = "https://devapi.uslegalservices.net/api/new_agent_portal/";
let MS_BASE = "https://devms.uslegalservices.net/usl";
let BASE_S3 = "https://uslawstests3.s3.amazonaws.com";
let ACCESS_KEY="XBTSGfzePInvuvhLrXmlYlyAl8X1zWzGN97NrADr";
let BASE_EXT = "https://devext.uslegalservices.net/";

if (
  window.location.origin != "https://devagentportal.uslegalservices.net" &&
  window.location.origin != "http://localhost:8080"
) {
  API_BASE = "https://api.uslegalservices.net/api/new_agent_portal/";
  MS_BASE = "https://usl.uslegalservices.net/usl";
  BASE_EXT = "https://ext.uslegalservices.net/";
}

const setDateFormat = date => {
  if (date != null && date != "" && date != "0000-00-00 00:00:00") {
    return moment(date).format("MM/DD/YYYY");
  } else if (date == "0000-00-00 00:00:00") {
    return "";
  }
};
export default {
  setDateFormat,
  documentTitle,
  API_BASE,
  MS_BASE,
  BASE_S3,
  ACCESS_KEY,
  BASE_EXT
};
